import { Component } from '@angular/core';

@Component({
  selector: 'smart-fix-bedrock-chat-welcome-message',
  templateUrl: './bedrock-chat-welcome-message.component.html',
  styleUrls: ['./bedrock-chat-welcome-message.component.scss'],
})
export class BedrockChatWelcomeMessageComponent {}
